import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'
import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'

export default {
  SET_LOADING(state, payload) {
    state.loading = payload
  },

  SET_ACTION_LOADING(state, payload) {
    state.actionLoading = payload
  },

  SET_SORT(state, payload) {
    state.sorting = payload
  },

  SET_RE_INVITE_LOADING(state, payload) {
    state.reInviteLoading = payload
  },

  SET_EXAMPLE_LOADING(state, payload) {
    state.exampleLoading = payload
  },

  SET_ITEMS(state, payload) {
    state.items = payload.items
    state.total = payload.total
    state.totalAll = payload.total_all
  },

  SET_FORM_DATA(state, payload) {
    Object.keys(state.formData).forEach((key) => {
      state.formData[key] = payload[key]
    })

    state.id = payload.id
    state.formData.approved_count =
      Number(state.formData.approved_count) +
      Number(state.formData.in_emcd_count)
  },

  SET_ID(state, payload) {
    state.id = payload
  },

  SET_SELECTED(state, payload) {
    state.selected = payload
  },

  SET_SEARCH(state, payload) {
    state.search = payload
  },

  SET_FILTER(state, { key, payload }) {
    state.filters[key] = payload
  },

  UPDATE_AFTER_RE_INVITE(state, payload) {
    const findIndex = state.items.findIndex(
      (item) => item.email === payload.email
    )

    if (findIndex !== -1) {
      state.items.splice(findIndex, 1, {
        ...state.items[findIndex],
        user_invitation_time: new Date(),
      })
    }
  },

  CLEAR_ITEMS(state) {
    state.page = 1
    state.items = []
  },

  SET_SUCCESS_FILE_LOADED(state, payload) {
    state.successFileLoaded = payload
  },

  SET_UPLOAD_ERRORS(state, payload) {
    state.uploadErrors = payload
  },

  SET_FORM_DATA_PAYMENT_INFO(state, payload) {
    Object.keys(state.formDataPaymentInfo).forEach((key) => {
      state.formDataPaymentInfo[key] = payload[key]
    })
  },

  RESET_STORE(state) {
    state.id = null
    state.loading = false
    state.actionLoading = false
    state.reInviteLoading = false
    state.exampleLoading = false
    state.formData = {
      approved_count: null,
      approved_sum: null,
      in_emcd_sum: null,
      description: null,
      invited_count: null,
      in_emcd_count: null,
      name: null,
      paid_count: null,
      paid_sum: null,
      pays_error_count: null,
      raw_error_count: null,
      id: null,
      fee_sum: null,
    }
    state.selected = []
    state.search = null
    state.filters = {
      contractor_statuses: [],
      payment_statuses: [],
    }
    state.formDataPaymentInfo = {
      amount: null,
      body: null,
      coin: null,
      fee: null,
    }
    state.sorting = {
      sort_by: SORT_ORDER.CONTRACTOR_STATUS,
      sort_direction: SORT_DIRECTION.DESC,
    }

    state.items = []
    state.page = 1
    state.limit = 10
    state.total = 0
    state.totalAll = 0
  },
}
